module.exports = __webpack_public_path__ + "img/weather.07ea9847.svg";